import React, { useEffect, useState } from 'react';

import "./CourseContent.css"
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../../utils/Constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import Swal from 'sweetalert2';
import "./Courses"
const CourseContent = () => {

    const [searchParams, setSearchParams] = useSearchParams();
    let id = searchParams.get("id")
    const location = useLocation();
    const image = location.state?.image || `${BASE_URL}/images/instructorhanan.jpg`; // Fallback image



    const [courseContent, setCourseContent] = useState<any>()
    const [userProgressCount, setUserProgressCount] = useState<any>()
    const [courseLessonsCount, setCourseLessonsCount] = useState<any>()


   useEffect(() => {
    Swal.showLoading();

    axios.post(`${BASE_URL}/course/getcourse.php`, { id: id })
        .then((res: any) => {
            const content = res.data.data.course_content;
            setCourseLessonsCount(content.length);

            // 1) Group lessons by module_id
            const grouped = content.reduce((acc: any, lesson: any) => {
                const mid = lesson.module_id;
                if (!acc[mid]) acc[mid] = [];
                acc[mid].push(lesson);
                return acc;
            }, {});

            // 2) Convert grouped object → array of modules
            let modulesArray = Object.keys(grouped).map((mid) => ({
                module_id: mid,
                module_order: parseInt(grouped[mid][0]?.module_order ?? "0", 10),
                module_name: grouped[mid][0]?.module_name,
                lessons: grouped[mid]
            }));

            // 3) Sort modules by module_order
            modulesArray.sort((a, b) => a.module_order - b.module_order);

            // Save in state
            setCourseContent(modulesArray);
            setUserProgressCount(res.data.data.user_progress_count);

            Swal.close();
        })
        .catch((error) => {
            Swal.fire("Error", error.response.data.msg, "error").then(() => {
                navigate("/");
            });
        });
}, []);

    const navigate = useNavigate();

    const handleLessonClick = (lesson:any)=>{
        axios.post(`${BASE_URL}/course/setlastlesson.php`, { lesson_id : lesson.lesson_id }).then((res: any) => {

            navigate(`/lesson?id=${lesson.lesson_id}&module_id=${lesson.module_id}`)
        }).catch((err: any) => {

        })
       
    }
    return (
        <div className="row">
            <div className="col-6">




                {

                   Array.isArray(courseContent) ? (
    courseContent.map((module) => {
                            

                            return (
                                <div className="module_container" key={module.module_id}>
    <div className="module_name">{module.module_name}</div>

    {module.lessons.map((lesson: any) => (
        <div
            className="lesson_container row mb-5"
            onClick={() => handleLessonClick(lesson)}
            key={lesson.lesson_id}
        >
            <div className="lesson_image col-3">
                <img
                    style={{ height: "150px" }}
                    src={`${BASE_URL}/images/${lesson?.lesson_image_path}`}
                />
            </div>

            <div className="col-9 d-flex align-items-center justify-content-between">
                {lesson.lesson_name}
                {lesson.status === "c" && (
                    <div className="text-right">
                        <FontAwesomeIcon icon={faCheck} />
                    </div>
                )}
            </div>
        </div>
    ))}
</div>

                            )

                        })
                    ) : null

                }


            </div>



            <div className="col-6">
                <div className="card" style={{ width: "25rem" }}>
                    <img className="card-img-top" src={image} alt="Card image cap" />
                    <div className="card-body">
                        <h5 className="card-title">{userProgressCount} of {courseLessonsCount} Lessons Completed</h5>

                    </div>
                </div>


                
            </div>

        </div>
    )
}



export default CourseContent